var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "questionnaire" },
    [
      _c("h2", { staticClass: "questionnaire-title" }, [
        _vm._v("Compliance Questionnaire"),
      ]),
      _vm._l(_vm.modulesQuestionData, function (moduleQuestion, index) {
        return _c(
          "div",
          { key: index, staticClass: "questionnaire-moudle" },
          [
            _c("div", { staticClass: "questionnaire-moudle-title" }, [
              _vm._v(_vm._s(_vm.num[index] + "." + moduleQuestion.en_name)),
            ]),
            _c(
              "el-descriptions",
              {
                attrs: {
                  column: 1,
                  border: "",
                  "content-style": _vm.contentStyle,
                },
              },
              _vm._l(moduleQuestion.questionList, function (question, qIndex) {
                return _c(
                  "el-descriptions-item",
                  { key: qIndex, staticClass: "descriptions-item" },
                  [
                    _c("template", { slot: "label" }, [
                      _vm._v(
                        " " +
                          _vm._s(qIndex + 1 + "." + question.question) +
                          " " +
                          _vm._s(
                            question.question_type === 1
                              ? "(single select)"
                              : "(multi-select)"
                          ) +
                          " "
                      ),
                    ]),
                    question.question_type === 1
                      ? _c(
                          "el-radio-group",
                          {
                            class: {
                              "line-single":
                                question &&
                                question.mch_naire_option_list.length > 2,
                            },
                            attrs: { size: "small" },
                            model: {
                              value: question.questionValue,
                              callback: function ($$v) {
                                _vm.$set(question, "questionValue", $$v)
                              },
                              expression: "question.questionValue",
                            },
                          },
                          [
                            _vm._l(
                              question.mch_naire_option_list,
                              function (rItem, rIndex) {
                                return [
                                  _c(
                                    "el-radio",
                                    { key: rIndex, attrs: { label: rItem.id } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "checkbox_content" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(rItem.option_value)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                    question.question_type === 2
                      ? _c(
                          "el-checkbox-group",
                          {
                            attrs: { size: "small" },
                            model: {
                              value: question.questionValue,
                              callback: function ($$v) {
                                _vm.$set(question, "questionValue", $$v)
                              },
                              expression: "question.questionValue",
                            },
                          },
                          [
                            _vm._l(
                              question.mch_naire_option_list,
                              function (cItem, cIndex) {
                                return [
                                  _c(
                                    "el-checkbox",
                                    {
                                      key: cIndex,
                                      class: {
                                        "line-single":
                                          question &&
                                          question.mch_naire_option_list
                                            .length > 2,
                                      },
                                      attrs: { label: cItem.id },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "checkbox_content" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(cItem.option_value)
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              1
            ),
          ],
          1
        )
      }),
      _c("div", { staticClass: "tip-title" }, [
        _vm._v(
          _vm._s(_vm.tipQuestionData[0] && _vm.tipQuestionData[0].en_name)
        ),
      ]),
      _c("div", { staticClass: "tip-content" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.tipQuestionData[0] &&
                _vm.tipQuestionData[0].questionList[0] &&
                _vm.tipQuestionData[0].questionList[0].question
            ) +
            " "
        ),
      ]),
      _c(
        "div",
        { staticClass: "btn-conatiner" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.submiting },
              on: { click: _vm.onClickSubmitBtn },
            },
            [_vm._v(_vm._s(_vm.$t("components.submit")))]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }